<template>
  <div class="page-fornitori-detail">
    <fornitori-detail />
  </div>
</template>

<script>
import FornitoriDetail from '@/components/ask/details/FornitoriDetail.vue'

export default {
  name: 'ViewFornitoriDetail',
  components: {
    FornitoriDetail,
  },

  data() {
    return {
      pageName: 'FornitoriDetail',
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },
  
}
</script>
